// app.config.ts
import { ApplicationConfig, provideExperimentalZonelessChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import Aura from '@primeng/themes/aura';
import { routes } from './app-routing.module';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { pricingErrorInterceptor } from './interceptors/pricing-error.interceptor';
import { AppInitializerService, initializeAppFactory } from './services/app-initializer.service';
import { PostHogErrorHandler } from './services/posthog-error-handler';

// Amplify Configuration
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';

// Configure Amplify
Amplify.configure(amplifyconfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([JwtInterceptor, pricingErrorInterceptor])
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
      }
    }),
    // PrimeNG MessageService for toast notifications (used by pricing interceptor)
    MessageService,
    // PrimeNG DialogService for dynamic dialogs (used by tier upgrade service)
    DialogService,
    // Initialize CSRF token on app startup
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [AppInitializerService],
      multi: true
    },
    // Route uncaught errors to PostHog error tracking (still logs to console).
    {
      provide: ErrorHandler,
      useClass: PostHogErrorHandler
    }
  ]
};